import(/* webpackMode: "eager" */ "/codebuild/output/src3800784703/src/github.com/Singularity-DAO/sfi-frontend/apps/dapp/app/error.tsx");
